var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { omit } from "lodash";
import { Decoration_Type, Node_Type } from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
import { ANCHOR_TYPE, LINK_TYPE, MENTION_TYPE } from "../../../consts";
import { FROM_RICOS_DECORATION_TYPE, TO_RICOS_DECORATION_DATA_FIELD } from "../consts";
import { emojiRegex } from "../emojiRegex";
import { createDecorationEntityData } from "./getDraftEntityData";
const isInlineStyleDecoration = (decorationType) => TO_RICOS_DECORATION_DATA_FIELD[decorationType] === void 0;
const pipe = (arg, ...fns) => {
  return fns.reduce((v, fn) => fn(v), arg);
};
const mergeTextNodes = (nodes) => {
  let length = 0;
  return (nodes != null ? nodes : []).reduce(
    ({ text, decorationMap }, currNode) => {
      let accText = text;
      if (currNode.textData) {
        const { text: currText, decorations: currDecorations } = currNode.textData;
        const textLength = Array.from(currText).length;
        accText += currText;
        if (currDecorations) {
          convertDecorationTypes(currDecorations).forEach((decoration) => {
            if (!decorationMap[decoration.type]) {
              decorationMap[decoration.type] = [];
            }
            decorationMap[decoration.type] = [
              ...decorationMap[decoration.type],
              __spreadProps(__spreadValues({}, decoration), {
                start: length,
                end: length + textLength
              })
            ];
          });
        }
        length += textLength;
      }
      return { text: accText, decorationMap };
    },
    { text: "", decorationMap: {} }
  );
};
const mergeParagraphNodes = (nodes) => {
  return nodes.reduce(
    ({ text, decorationMap }, currNode) => {
      var _a;
      if (currNode.type !== Node_Type.PARAGRAPH && currNode.type !== Node_Type.HEADING) {
        return { text, decorationMap };
      }
      const currentText = mergeTextNodes((_a = currNode.nodes) != null ? _a : []);
      const shouldAddNewLineBetween = text && text !== "";
      const previousText = shouldAddNewLineBetween ? `${text}
` : text;
      const resultText = `${previousText}${currentText.text}`;
      const movedNewDecorationMap = moveDecorationsMapByPreviousTextLength(
        previousText,
        currentText.decorationMap
      );
      const mergedDecorationMap = mergeDecorationMap(decorationMap, movedNewDecorationMap);
      return { text: resultText, decorationMap: mergedDecorationMap };
    },
    { text: "", decorationMap: {} }
  );
};
const mergeDecorationMap = (oldDecorationMap, newDecorationMap) => {
  return Object.entries(newDecorationMap).reduce(
    (acc, [decorationType, decorations]) => {
      var _a;
      return __spreadProps(__spreadValues({}, acc), {
        [decorationType]: [...(_a = acc[decorationType]) != null ? _a : [], ...decorations]
      });
    },
    oldDecorationMap
  );
};
const moveDecorationsMapByPreviousTextLength = (textBefore, decorationMap) => {
  return Object.entries(decorationMap).reduce(
    (acc, [decorationType, decorations]) => {
      return __spreadProps(__spreadValues({}, acc), {
        [decorationType]: decorations.map((decoration) => __spreadProps(__spreadValues({}, decoration), {
          start: decoration.start + textBefore.length,
          end: decoration.end + textBefore.length
        }))
      });
    },
    {}
  );
};
const parseDecorations = (decorationMap, text) => {
  const nonMergableDecorations = [LINK_TYPE, MENTION_TYPE, ANCHOR_TYPE];
  const decorations = Object.values(decorationMap).sort(decorationComparator).reduce((decorations2, currentDecorations) => {
    if (currentDecorations.length > 0) {
      const firstDecoration = currentDecorations.shift();
      const mergedDecorations = [firstDecoration];
      currentDecorations.forEach((decoration) => {
        const lastDecoration = mergedDecorations.pop();
        if (decoration.start === lastDecoration.end && !nonMergableDecorations.includes(decoration.type)) {
          mergedDecorations.push(__spreadProps(__spreadValues({}, lastDecoration), { end: decoration.end }));
        } else {
          mergedDecorations.push(lastDecoration, decoration);
        }
      });
      return [...decorations2, ...mergedDecorations.sort(decorationComparator)];
    }
    return decorations2;
  }, []);
  const allDecorations = [...decorations, ...createEmojiDecorations(text)];
  const entityDecorations = allDecorations.filter(({ type }) => !isInlineStyleDecoration(type)).sort(decorationComparator);
  const inlineStyleDecorations = allDecorations.filter(({ type }) => isInlineStyleDecoration(type));
  return { inlineStyleDecorations, entityDecorations };
};
const parseInlineStyleDecorations = (decorations) => {
  const inlineStyleRanges = decorations.reduce(
    (inlineStyleRanges2, decoration) => [
      ...inlineStyleRanges2,
      {
        style: decoration.type,
        offset: decoration.start,
        length: decoration.end - decoration.start
      }
    ],
    []
  );
  return inlineStyleRanges;
};
const parseEntityDecorations = (decorations, latestEntityKey) => {
  const {
    entityRanges,
    entityMap,
    latestEntityKey: newLatestEntityKey
  } = decorations.reduce(
    ({ entityRanges: entityRanges2, entityMap: entityMap2, latestEntityKey: latestEntityKey2 }, decoration) => {
      const newEntityKey = latestEntityKey2 + 1;
      const newEntityMap = createDecorationEntityData(decoration, newEntityKey);
      return {
        entityRanges: [
          ...entityRanges2,
          {
            key: newEntityKey,
            offset: decoration.start,
            length: decoration.end - decoration.start
          }
        ],
        entityMap: __spreadValues(__spreadValues({}, entityMap2), newEntityMap),
        latestEntityKey: newEntityKey
      };
    },
    { entityRanges: [], entityMap: {}, latestEntityKey }
  );
  return {
    entityRanges,
    entityMap,
    latestEntityKey: newLatestEntityKey
  };
};
const getParagraphNode = (node) => {
  var _a, _b;
  if (((_a = node.nodes) == null ? void 0 : _a[0].type) === Node_Type.PARAGRAPH) {
    return node.nodes[0];
  } else {
    throw Error(`Expected a paragraph node but found ${(_b = node.nodes) == null ? void 0 : _b[0].type}`);
  }
};
const convertDecorationTypes = (decorations) => decorations.flatMap(
  (decoration) => pipe(
    decoration,
    toDraftDecorationType,
    convertFontSize,
    convertFontWeight,
    convertItalic,
    convertUnderline,
    splitColorDecoration
  )
);
const createEmojiDecorations = (text) => {
  const result = [];
  let match;
  while ((match = emojiRegex.exec(text)) !== null) {
    const { 0: emojiUnicode, index: start } = match;
    const decoration = {
      type: "EMOJI_TYPE",
      emojiData: { emojiUnicode },
      start,
      end: start + Array.from(emojiUnicode).length
    };
    result.push(decoration);
  }
  return result;
};
const toDraftDecorationType = (decoration) => {
  const type = omit(FROM_RICOS_DECORATION_TYPE, [
    Decoration_Type.BOLD,
    Decoration_Type.ITALIC,
    Decoration_Type.UNDERLINE
  ])[decoration == null ? void 0 : decoration.type];
  return type ? __spreadProps(__spreadValues({}, decoration), { type }) : decoration;
};
const splitColorDecoration = (_a) => {
  var _b = _a, {
    colorData
  } = _b, decoration = __objRest(_b, [
    "colorData"
  ]);
  if (!colorData) {
    return decoration;
  }
  const { foreground, background } = colorData;
  return [foreground && { FG: foreground }, background && { BG: background }].filter((x) => x).map((type) => __spreadProps(__spreadValues({}, decoration), { type: JSON.stringify(type) }));
};
const convertFontSize = (_c) => {
  var _d = _c, {
    fontSizeData
  } = _d, decoration = __objRest(_d, [
    "fontSizeData"
  ]);
  var _a, _b;
  return fontSizeData ? __spreadProps(__spreadValues({}, decoration), {
    type: JSON.stringify({
      "font-size": ((_a = fontSizeData.value) == null ? void 0 : _a.toString()) + (((_b = fontSizeData.unit) == null ? void 0 : _b.toLowerCase()) || "px")
    })
  }) : decoration;
};
const convertFontWeight = (_e) => {
  var _f = _e, {
    fontWeightValue
  } = _f, decoration = __objRest(_f, [
    "fontWeightValue"
  ]);
  return decoration.type === Decoration_Type.BOLD ? __spreadProps(__spreadValues({}, decoration), {
    type: !fontWeightValue || fontWeightValue >= 700 ? "BOLD" : "NOT_BOLD"
  }) : decoration;
};
const convertItalic = (_g) => {
  var _h = _g, {
    italicData
  } = _h, decoration = __objRest(_h, [
    "italicData"
  ]);
  const isItalicDataUndefined = typeof italicData === "undefined";
  return decoration.type === Decoration_Type.ITALIC ? __spreadProps(__spreadValues({}, decoration), {
    type: isItalicDataUndefined || italicData ? "ITALIC" : "NOT_ITALIC"
  }) : decoration;
};
const convertUnderline = (_i) => {
  var _j = _i, {
    underlineData
  } = _j, decoration = __objRest(_j, [
    "underlineData"
  ]);
  const isUnerlineDataUndefined = typeof underlineData === "undefined";
  return decoration.type === Decoration_Type.UNDERLINE ? __spreadProps(__spreadValues({}, decoration), {
    type: isUnerlineDataUndefined || underlineData ? "UNDERLINE" : "NOT_UNDERLINE"
  }) : decoration;
};
const decorationComparator = (a, b) => "start" in a && "start" in b ? a.start - b.start : a[0].start - b[0].start;
export {
  getParagraphNode,
  mergeParagraphNodes,
  mergeTextNodes,
  parseDecorations,
  parseEntityDecorations,
  parseInlineStyleDecorations
};
//# sourceMappingURL=decorationParsers.js.map
